import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=0f5f8e4e&"
import script from "./AddProjectModal.vue?vue&type=script&lang=js&"
export * from "./AddProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports